import selector from 'modules/Auth/selectors.js'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import { systemConfig } from 'utils/config.js'
import corporateRequest from 'utils/corporateRequest'
import elasticSearchRequest from 'utils/elasticSearchRequest'
import instituteRequest from 'utils/instRequest'
import request from 'utils/request'
import studentRequest from 'utils/studentRequest'
import elasticSearchSyncRequest from '../../../utils/elasticSearchSyncRequest'
export const SET_USER_COUNTRIES = 'corporate/SET_USER_COUNTRIES'
export const SET_COMPANY_MASTER = `corporate/SET_COMPANY_MASTER`
export const SET_NEW_COMPANY_LIST = `corporate/SET_NEW_COMPANY_MASTER`
export const SET_ROLE_DATA = `corporate/SET_ROLE_DATA_PREVIEW`
export const SET_JD_ROLE_DATA = `corporate/SET_JD_ROLE_DATA`
export const SET_UPDATED_DATA = `corporate/SET_UPDATED_DATA`
export const SET_ELASTIC_SEARCH_DEGREE_DATA = `SET_ELASTIC_SEARCH_DEGREE_DATA`
export const SET_SPECIALISATION_LIST = 'corporate/SET_SPECIALISATION_LIST'
export const SET_METRICS = 'corporate/SET_DRIVE_METRICS'
export const SET_JOB_CATEGORY = `SET_JOB_CATEGORY`

export const setListOfCountry = data => {
  return {
    type: 'SET_USER_COUNTRIES',
    data,
  }
}
export const setNewCompany = data => {
  return {
    type: SET_COMPANY_MASTER,
    data,
  }
}
export const setListOfPerfCity = data => {
  return {
    type: 'SET_LIST_OF_PERF_CITY',
    data,
  }
}
export const setMetrics = data => {
  return {
    type: SET_METRICS,
    data,
  }
}
export const setCompanyList = data => {
  return {
    type: SET_NEW_COMPANY_LIST,
    data,
  }
}
export const setRoleData = data => {
  return {
    type: SET_ROLE_DATA,
    data,
  }
}
export const setJDData = data => {
  return {
    type: SET_JD_ROLE_DATA,
    data,
  }
}
export const setUpdatedRoleData = data => {
  return {
    type: SET_UPDATED_DATA,
    data,
  }
}

export const setElasticSearchDegreeData = data => {
  return {
    type: SET_ELASTIC_SEARCH_DEGREE_DATA,
    data,
  }
}
export const setSpecialisationList = data => {
  return {
    type: SET_SPECIALISATION_LIST,
    data,
  }
}
export const setJobCategory = data => {
  return {
    type: SET_JOB_CATEGORY,
    data,
  }
}

export const getJobCategory = id => async (dispatch, getState) => {
  const state = getState()
  try {
    const instituteCampusId = selector.getInstituteDetails(state).id
    const result = await corporateRequest.get(
      `/corporates/filters/jobtype/instituteCampus/${instituteCampusId}/jobs`
    )
    // resolve(result?.data)
    return result?.data
  } catch (error) {
    //console.log(error)
  }
}

export const getListOfCountries =
  ({ searchValue, pageLimit = 50, currentPage = 0 }) =>
  async (dispatch, getState) => {
    let searchKey = searchValue ? `&search=${searchValue}` : ''
    try {
      let response = await request.get(
        `/search/countries?pageLimit=${pageLimit}${searchKey}`
      )
      dispatch(setListOfCountry(response?.data?.data?.result || []))
      return response
    } catch (error) {
      console.error('Error in getting list of countries.', error)
      ErrorMessage(error?.response)
      return error?.response
    }
  }

export const addNewCompany =
  (payload, handleAddNewCompany) => async (dispatch, getState) => {
    try {
      const result = await corporateRequest.post(
        `/corporate/institute/company`,
        payload
      )
      SuccessMessage('New company added successfully')
      handleAddNewCompany(false)
      return result
    } catch (error) {
      ErrorMessage(error?.message)
    }
  }
export const getListOfCompanies = search => async (dispatch, getState) => {
  try {
    let response = await corporateRequest.get(
      `/corporate/institute/company?search=${search}`
    )
    dispatch(setCompanyList(response?.data?.data?.result || []))
    return response
  } catch (error) {
    console.error('Error in getting list of countries.', error)
    ErrorMessage(error?.response)
    return error?.response
  }
}
export const addNewRole =
  (instituteCampusId, payload, setLoad) => async (dispatch, getState) => {
    setLoad('')
    try {
      const result = await corporateRequest.post(
        `/corporates/instituteCampus/${instituteCampusId}/job`,
        payload
      )
      const queryPayload = {
        query_date: new Date().toISOString().split('T')[0],
      }
      dispatch(setRoleData(result?.data?.data));

      await elasticSearchSyncRequest.post(
        `/sync/student_crud_skill`,
        queryPayload
      )
      await elasticSearchSyncRequest.post(`/sync/skill_master`, queryPayload)
      setLoad('Success')
      return result?.data
    } catch (error) {
      setLoad('Failure')
      ErrorMessage(error?.response?.data?.message)
      throw error
    }
  }
export const updateNewRole =
  (instituteCampusId, payload, setLoad, id, setButtonLoading) =>
  async (dispatch, getState) => {
    try {
      const result = await corporateRequest.put(
        `/corporates/instituteCampus/${instituteCampusId}/job/${id}`,
        payload
      )
      const queryPayload = {
        query_date: new Date().toISOString().split('T')[0],
      }

      await elasticSearchSyncRequest.post(
        `/sync/student_crud_skill`,
        queryPayload
      )
      await elasticSearchSyncRequest.post(`/sync/skill_master`, queryPayload)
      dispatch(setRoleData(result?.data?.data))
      setLoad('Success')
      setButtonLoading && setButtonLoading(false)
      return result?.data
    } catch (error) {
      setLoad('Failure')
      setButtonLoading && setButtonLoading(false)
      ErrorMessage(error?.response?.data?.message)
      throw error
    }
  }

export const getRoleDetails = roleId => async (dispatch, getState) => {
  try {
    const result = await corporateRequest.get(`/corporates/jobs/${roleId}`)
    return result?.data
  } catch (error) {
    ErrorMessage(error?.message)
  }
}

export const getElasticSearchDegreeData =
  ({ searchValue }) =>
  async (dispatch, getState) => {
    let payLoad = systemConfig?.degree_streams
    payLoad.q = searchValue || ''
    try {
      const result = await elasticSearchRequest.post(
        `/search/degrees/streams`,
        payLoad
      )
      let data = result.data.data?.hits?.hits
      dispatch(setElasticSearchDegreeData(data || {}))

      return result
    } catch (error) {
      ErrorMessage(error?.message)
    }
  }
export const getSpecialisationList = payload => async (dispatch, getState) => {
  try {
    const result = await instituteRequest.post(
      `/institutes/specialitationList`,
      payload
    )
    dispatch(setSpecialisationList(result?.data?.data || []))
    return result
  } catch (error) {
    ErrorMessage(error?.message)
    return error?.response
  }
}

export const getCandidateMetrics =
  (payload, setLoad) => async (dispatch, getState) => {
    const state = getState()
    const instituteId = selector.getInstituteDetails(state).id
    try {
      const result = await studentRequest.post(
        `/students/count/${instituteId}`,
        payload
      )
      return result?.data?.data
    } catch (error) {}
  }

export const getMetrics =
  (instituteCampusId, roleId, rolePublishedBy = 'INSTITUTE') =>
  async (dispatch, getState) => {
    try {
      const result =
        rolePublishedBy == 'INSTITUTE'
          ? await corporateRequest.get(
              `/corporates/instiuteCampus/${instituteCampusId}/jobs/${roleId}/candidate/metrics`
            )
          : await corporateRequest.get(
              `/corporates/roles/${roleId}/metrix?instituteCampusId=${instituteCampusId}`
            )
      return result?.data?.data
    } catch (error) {
      ErrorMessage(error?.message)
    }
  }

export const getCandidate =
  (
    instituteCampusId,
    roleId,
    stage,
    statusIndex,
    search,
    multiSelect,
    degreeId,
    departId,
    rolePublishedBy,
    sortBy,
    status = 'ACTIVE',
    pageNumber = 0,
    bulkDownload,
    checkSkills,
    checkYear,
    scoreEntries,
    checkArrears,
    checkGender,
    checkLocation,
    specialisationId
  ) =>
  async (dispatch, getState) => {
    let payLoad = {}
    let getMultiData = multiSelect
      .filter(
        item =>
          item.key !== 'UPDATE_STATUS' && item.nameValue !== 'Status - Rejected'
      )
      .map(item => item.key)
      .join(',')

    let statusActive =
      multiSelect?.length !== 0 &&
      multiSelect
        ?.filter(
          item =>
            item.key === 'UPDATE_STATUS' ||
            item.nameValue === 'Status - Rejected'
        )
        .map(item => item.key)

    rolePublishedBy == 'INSTITUTE'
      ? statusIndex !== 'undefined' && statusIndex
        ? (payLoad.stageIndex = statusIndex)
        : ``
      : stage && stage !== 'all_candidates'
      ? (payLoad.stage = stage)
      : ''

    status === 'ACTIVE' ||
    status === 'UPDATE_STATUS' ||
    (statusActive && statusActive?.includes('REJECTED'))
      ? multiSelect.length !== 0
        ? statusActive && statusActive?.includes('REJECTED')
          ? rolePublishedBy == 'INSTITUTE'
            ? (payLoad.status =
                stage === 'offer' ? 'UPDATE_STATUS' : statusActive.join(','))
            : (payLoad.driveStatus =
                stage === 'offer' ? 'UPDATE_STATUS' : statusActive.join(','))
          : statusActive && statusActive?.includes('UPDATE_STATUS')
          ? (payLoad.status =
              stage === 'offer' ? 'UPDATE_STATUS' : statusActive.join(','))
          : ''
        : ''
      : stage === 'offer' && status !== 'ACTIVE'
      ? (payLoad.offerStatus = status)
      : status && stage !== 'all_candidates'
      ? rolePublishedBy == 'INSTITUTE'
        ? (payLoad.status = status)
        : (payLoad.driveStatus = status)
      : ``

    if (stage === 'offer' && status === 'ACTIVE' && statusActive) {
      payLoad.offerStatus = 'NOT_RELEASED'
    } else if (getMultiData !== '') {
      if (rolePublishedBy == 'INSTITUTE') {
        if (getMultiData === 'ABSENT') {
          let absentData = [...statusActive, 'ABSENT']
          payLoad.status = absentData.join(',')
        } else {
          let absentData = getMultiData?.includes('ABSENT')
          if (absentData) {
            absentData = [...statusActive, 'ABSENT']
            payLoad.status = absentData.join(',')
            let releasedData = getMultiData?.includes('RELEASED')
            let acceptData = getMultiData?.includes('ACCEPTED')
            let rejectData = getMultiData?.includes('REJECTED')
            if (releasedData && acceptData && rejectData) {
              payLoad.offerStatus = 'RELEASED,ACCEPTED,REJECTED'
            } else if (releasedData && acceptData) {
              payLoad.offerStatus = 'RELEASED,ACCEPTED'
            } else if (releasedData && rejectData) {
              payLoad.offerStatus = 'RELEASED,REJECTED'
            } else if (acceptData && rejectData) {
              payLoad.offerStatus = 'ACCEPTED,REJECTED'
            } else {
              payLoad.offerStatus =
                releasedData || acceptData || rejectData
                  ? releasedData
                    ? 'RELEASED'
                    : acceptData
                    ? 'ACCEPTED'
                    : 'REJECTED'
                  : ''
            }
          } else {
            payLoad.offerStatus = getMultiData
          }
        }
      } else {
        let offerStatus = multiSelect
          .filter(item => item.isOfferStatus)
          .map(item => item.key)
          .join(',')
        let driveStatus = multiSelect
          ?.filter(
            item => item.isOfferStatus === undefined || !item.isOfferStatus
          )
          ?.map(item => item.key)
          ?.join(',')
        payLoad.driveStatus = driveStatus
        if (offerStatus) payLoad.offerStatus = offerStatus
      }
    }

    if (search !== '') {
      if (rolePublishedBy == 'INSTITUTE') {
        payLoad.search = search?.trim()
      } else {
        payLoad.searchBy = search?.trim()
      }
    }
    let degreeSet = []

    if (degreeId.length !== 0 || departId.length !== 0 || specialisationId?.length !== 0) {
      degreeId.length !== 0 &&
        degreeId.forEach(element => {
          degreeSet?.push({ degreeId: element?.value, streamId: [], specialisationId: [] });
        });
    
      if (departId.length !== 0) {
        departId.forEach(element => {
          if (degreeSet.length !== 0) {
            degreeSet.forEach(item => {
              if (item.degreeId === element.degreeId) {
                if (!item.streamId) {
                  item.streamId = [];
                }
                item.streamId.push(element.departId);
              }
            });
          }
        });
      }
    
      if (specialisationId?.length !== 0) {
        specialisationId?.forEach(element => {
          if (degreeSet?.length !== 0) {
            degreeSet.forEach(degreeItem => {
              if (degreeItem.degreeId === element.degreeId) {
                if (!degreeItem.specialisationId) {
                  degreeItem.specialisationId = [];
                }
                degreeItem.specialisationId.push(element.specialisationId);
              }
            });
          }
        });
      }
    
      if (degreeSet?.length !== 0) {
        payLoad.degreeIds = degreeSet;
      }
    }
    
    
    if (sortBy?.columnKey) {
      payLoad.sort = sortBy.columnKey
    }
    if (checkSkills?.length !==0){
      payLoad.skillIds = checkSkills.map(skill => skill.id || skill)
    }
    if (checkYear?.length !==0){
      payLoad.yearOfPassing = checkYear.map(year => year.value || year).join(',')
    }
    if (scoreEntries?.length !==0) {
      const scores = {};
      
      scoreEntries.forEach(entry => {
        if (entry.qualification && entry.qualification.value) {
          scores[entry.qualification.value] = entry.percentage || 0;
        }
      });
      
      payLoad.scores = scores;
      payLoad.scoreFilterType = scoreEntries[0]?.comparisonType === 'greaterThan' ? 'gte' : 'lte'
    }
    // else{
    //   const score = {
    //     "tenth": 0,
    //     "twelfth": 0,
    //     "twelfthOrDiploma": 0,
    //     "ugDiploma": 0,
    //     "pgDiploma": 0,
    //     "ug": 0,
    //     "pg": 0
    // }
    //   payLoad.scores = score
    //   payLoad.scoreFilterType = 'gte'
    // }
    if(checkArrears?.past || checkArrears?.current){
      const arrears = {};
      
      if (checkArrears.past && checkArrears.past.toString().trim() !== '') {
        arrears.past = parseInt(checkArrears.past) || 0;
      }
      
      if (checkArrears.current && checkArrears.current.toString().trim() !== '') {
        arrears.current = parseInt(checkArrears.current) || 0;
      }
      
      if (checkArrears.pastType) {
        arrears.pastType = checkArrears.pastType;
      }
      
      if (checkArrears.currentType) {
        arrears.currentType = checkArrears.currentType;
      }
      
      payLoad.arrears = arrears;
    }
    if(checkGender?.length !==0){
      payLoad.gender = checkGender.map(gender => gender.value || gender).join(',')
    }
    if(checkLocation?.length !==0){
      payLoad.locationIds = checkLocation.map(location => location.value || location)
    }
    const order = sortBy?.order === 'ascend' ? 'asc' : 'desc'
    if (sortBy?.order) {
      payLoad.order = order
    }

    if (rolePublishedBy != 'INSTITUTE') {
      payLoad.forInstitute = true
      payLoad.collegeId = instituteCampusId
    }
    if (bulkDownload === true) {
      payLoad.bulkDownload = true
    }
    payLoad.pageNo = pageNumber
    payLoad.pageLimit = 10
    try {
      const result =
        rolePublishedBy == 'INSTITUTE'
          ? await studentRequest.post(
              `/students/instiuteCampus/${instituteCampusId}/jobs/${roleId}/evaluation/candidate/list`,
              payLoad
            )
          : await studentRequest.post(
              `students/role/${roleId}/applicant/list`,
              payLoad
            )
      return result?.data
    } catch (error) {}
  }

export const getJdDetails = (instituteCampusId, url) => async () => {
  try {
    const result = await corporateRequest.get(
      `/corporates/${instituteCampusId}/jdData?url=${url}`
    )
    return result?.data?.data
  } catch (error) {
    return null
  }
}

export const deleteJobRole = roleId => async () => {
  try {
    const result = await corporateRequest.delete(`/corporates/role/${roleId}`)
    return result?.data
  } catch (error) {
    ErrorMessage(error?.response?.data?.message)
    return false
  }
}

export const revertInEligibleStudent = (roleId,payload) => async () => {
  try {

    const result = await corporateRequest.post(`/corporates/revertInEligibleStudent/${roleId}`,payload)
    return result?.data
  } catch (error) {
    ErrorMessage(error?.response?.data?.message)
    return false
  }
}

export const searchCities =
  ({ searchValue, pageLimit = 50, currentPage = 0, countryId, stateId }) =>
  async () => {
    let searchKey = searchValue ? `&search=${searchValue}` : ''
    let countryID = countryId ? `&countryId=${countryId}` : ''
    let stateID = stateId ? `&stateId=${stateId}` : ''
    try {
      let response = await request.get(
        `/search/cities?pageLimit=${pageLimit}${countryID}${stateID}${searchKey}`
      )
      return response?.data?.data?.result
    } catch (error) {
      console.error('Error in getting list of citites.', error)
      ErrorMessage(error?.response)
      return error?.response
    }
  }

export const getCities = searchValue => async (dispatch, getState) => {
  let SearchKey = searchValue ? `search=${searchValue}` : ''
  //console.log(SearchKey)
  try {
    const result = await elasticSearchRequest.get(
      `search/states/cities?${SearchKey}`
    )
    dispatch(setListOfPerfCity(result?.data?.data))

    return result?.data?.data
  } catch (error) {
    //console.log('Error in getting list of degree =>', error?.message)
    dispatch(setListOfPerfCity([]))
  }
}
export const getInEligibleCandidates = roleId => async (dispatch, getState) => {
  const state = getState()

  try {
    const instituteCampusId = selector.getInstituteDetails(state).id
    let payLoad = {
      "instituteCampusId": instituteCampusId,
      "forMail":true,
      "roleId": roleId
    }
    const result = await corporateRequest.post(
      `corporate/inEligibleCandidates`, payLoad
    )
   
    return result?.data?.data
  } catch (error) {
    //console.log('Error in getting list of degree =>', error?.message)
    return error?.response
  }
}